module.exports = __webpack_public_path__ + "img/1556681158.bf38e14c.jpg";